import { allpeepNoPayloadEndpoint, allpeepPayloadEndpoint } from './helpers.js';
export const server = (rawClient) => ({
    info: allpeepNoPayloadEndpoint(rawClient, '/server/info'),
    config: {
        capabilities: allpeepNoPayloadEndpoint(rawClient, '/server/config/capabilities'),
    },
    keys: {
        webhooks: {
            public: allpeepNoPayloadEndpoint(rawClient, '/server/keys/webhooks'),
            verify: allpeepPayloadEndpoint(rawClient, '/server/keys/webhooks/verify', 'post'),
        },
    },
});
